import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import type { OffsetPageQueryDTO } from "@/shared/contracts/base";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { usePaymentsQuery } from "../api/queries";
import { PaymentSummaryCard } from "../ui/PaymentSummaryCard";
import { PaymentsFilter } from "../ui/PaymentsFilter";
import { PaymentsTable } from "../ui/PaymentsTable";
import { PaymentsToolbar } from "../ui/PaymentsToolbar";

export function PaymentsPage() {
  const nav = useNavigate({ from: "/app/payments" });
  const search: OffsetPageQueryDTO = useSearch({ from: "/app/payments" });
  const list = usePaymentsQuery({
    offset: search.offset,
    limit: search.limit,
    sort: search.sort,
    filters: search.filters,
  });

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ການຊຳລະ" },
          ]}
        />
      </Header>
      <Main>
        <PaymentsToolbar />
        <div className="mb-4">
          <PaymentSummaryCard />
        </div>
        <div className="flex flex-col rounded-xl border bg-card pt-2">
          <PaymentsFilter />
          <PaymentsTable
            data={list.data?.data ?? []}
            isLoading={list.isLoading}
            offset={search.offset ?? 0}
            limit={search.limit ?? 20}
            totalCount={list.data?.meta?.total ?? 0}
            sortBy={search.sort?.[0]?.field}
            sortOrder={search.sort?.[0]?.dir as "asc" | "desc" | undefined}
            onPaginationChange={(offset, limit) =>
              nav({ search: { ...search, offset, limit } })
            }
            onSortingChange={(id, desc) =>
              nav({
                search: {
                  ...search,
                  sort: [{ field: id, dir: desc ? "desc" : "asc" }],
                },
              })
            }
            onView={(row) =>
              nav({ to: "/app/payments/$id", params: { id: row.id } })
            }
          />
        </div>
      </Main>
    </>
  );
}
